import React, { ReactNode, useEffect } from "react";
import { useAppSelector } from "../../../store/hooks/StoreHooks";
import Breadcrumb from "./Breadcrumb";
import Success from "../../../assets/icons/Success";
import { ProjectStatus } from "../../../utilities/AppConstants";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCustomerCreated } from "../../../store/dashboard/AuthSlice";
import useProjectFacade from "../../../facade/project.Facade";

interface HeaderProps {
    showBreadCrumb?: boolean;
    headerActionTemplate?: ReactNode
}


const Header: React.FC<HeaderProps> = ({
    showBreadCrumb = false,
    headerActionTemplate,
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { ID, caseID } = useParams();
    const projectID = ID?.split("projectID=")?.[1] || "";
    const caseId = caseID?.split("caseID=")?.[1] || "";
    const projectId = caseId || projectID;
    const { isComparison } = useAppSelector(state => state?.comparison);
    const { isReports } = useAppSelector(state => state?.reports);
    const { projectAndAffiliations } = useAppSelector((state) => state?.projectHeader);
    const activeSectionName = isComparison ? 'Comparison' : isReports ? 'Reports' : 'DETERMINE sizing project';
    const tab4Input: any = useAppSelector((state) => state?.projectTab?.tab4Input);
    const { customerEnabled, user } = useAppSelector((state) => state?.auth);
    const { hasProjectAccess } = useAppSelector((state) => state?.myProjects);
    const { getHasUserProjectAccess } = useProjectFacade();

    useEffect(() => {
        if (customerEnabled) {
            let isCustomerCreated = projectAndAffiliations?.find((project: any) => project.projectID === projectId);
            dispatch(setCustomerCreated(isCustomerCreated?.userRole?.toLowerCase()?.includes('customer') && isCustomerCreated?.created_By === user?.userID ? true : false));
            getHasUserProjectAccess(projectId);
        }
    }, [projectAndAffiliations, customerEnabled])

    useEffect(() => {
        if (!hasProjectAccess && projectId) {
            navigate('/no-project-access');
        }
        if (projectId && projectAndAffiliations?.length === 0) {
            navigate('/no-project-access');
        }
    }, [hasProjectAccess])

    const getStatusTemplate = () => {
        if (projectAndAffiliations?.find((x: any) => x.status === ProjectStatus.acknowldged)) {
            return <div className={`flex gap-1 items-center border-solid border-[1px] rounded-md px-2 py-1 text-[#48bb78] font-bold text-sm border-[#48bb78]`}>
                <Success color="#48bb78" size={16} />&nbsp;Acknowledged
            </div>
        } else if (projectAndAffiliations?.find((x: any) => x.status === ProjectStatus.needReview)) {
            return <div className={`border-solid border-[1px] rounded-md px-2 py-1 text-lightorange-500 font-bold text-sm border-lightorange-500`}>
                Need review
            </div>
        } else if (projectAndAffiliations?.find((x: any) => x.status === ProjectStatus.reviewInProgress)) {
            return <div className={`border-solid border-[1px] rounded-md px-2 py-1 text-darkblue-400 font-bold text-sm border-darkblue-400`}>
                Review in-progress
            </div>
        } else if (projectAndAffiliations?.find((x: any) => x.status === ProjectStatus.customerReady)) {
            return <div className={`border-solid border-[1px] rounded-md px-2 py-1 text-darkblue-400 font-bold text-sm border-darkblue-400`}>
                Customer ready
            </div>
        } else if (projectAndAffiliations?.find((x: any) => x.status === ProjectStatus.inProgress)) {
            return <div className={`border-solid border-[1px] rounded-md px-2 py-1 text-neutral-100 font-bold text-sm border-neutral-100`}>
                In progress
            </div>
        }
    }

    const breadcrumbOptions = [{ name: 'Dashboard', link: '/dashboard' }, { name: activeSectionName, link: window.location.pathname }];
    return (
        <div className="px-[32px] pt-[24px] pb-[20px] flex w-full items-center shrink-0 gap-[8px] bg-darkcolor-700 sticky top-0 z-[1001]">
            {showBreadCrumb ? (
                <div className="flex justify-between w-full items-end">
                    <div className="flex flex-col">
                        <Breadcrumb items={breadcrumbOptions} />
                        {
                            tab4Input?.projectName &&
                            <>
                                <div className="text-neutral-25 text-[28px] font-bold mt-3">
                                    {tab4Input?.projectName}
                                </div>
                                <div className="flex gap-1  mt-1 items-center">
                                    <div className="text-neutral-100 font-normal text-sm">{tab4Input?.companyName}  &nbsp;|&nbsp;</div>
                                    <div className="text-primary-400 font-bold text-sm">{tab4Input?.wellName} &nbsp;|&nbsp;</div>

                                    {projectId && getStatusTemplate()}
                                </div>
                            </>
                        }
                    </div>
                    {
                        headerActionTemplate &&
                        <div className="flex h-full items-end">
                            {headerActionTemplate}
                        </div>
                    }
                </div>
            ) : (
                <label
                    className="text-[23px] font-medium text-neutral-25"
                >
                    My dashboard
                </label>
            )
            }
        </div >
    );
};

export default Header;
